import { ThirdPartyName } from '@common/enums/thirdPartyName';

export enum FundusScreeningThirdParty {
    healthConnectedFundusManualImport = ThirdPartyName.healthConnectedFundusManualImport,
    healthConnectedFundusNisIntegration = ThirdPartyName.healthConnectedFundusNisIntegration,
    vipLiveFundusManualImport = ThirdPartyName.vipLiveFundusManualImport,
}
